import { useState } from "react";

const NAV_ITEMS = [
  { href: "#examples", label: "制作イメージ" },
  { href: "#service", label: "サービス内容" },
  { href: "#flow", label: "制作の流れ" },
  { href: "#faq", label: "よくある質問" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-navy-100 bg-cream/90 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-navy-900 text-lime-400">
            <i className="ri-flashlight-line text-base" aria-hidden="true" />
          </span>
          <span className="font-heading text-base font-bold tracking-tight text-navy-900">
            短納期ホームページ制作
          </span>
          <span className="rounded-full border border-navy-200 px-2 py-0.5 text-[10px] font-medium text-navy-500">
            準備中
          </span>
        </a>

        <nav className="hidden items-center gap-7 md:flex" aria-label="メインナビゲーション">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap text-sm font-medium text-navy-700 transition-colors hover:text-navy-950"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          className="hidden whitespace-nowrap rounded-md bg-lime-400 px-4 py-2.5 text-sm font-bold text-navy-950 transition-colors hover:bg-lime-500 md:inline-flex"
        >
          公開日について相談する
        </a>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-controls="mobile-menu"
          aria-label="メニューを開く"
          className="flex h-10 w-10 items-center justify-center rounded-md text-navy-900 transition-colors hover:bg-navy-50 md:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`} aria-hidden="true" />
        </button>
      </div>

      {open && (
        <div id="mobile-menu" className="border-t border-navy-100 bg-cream md:hidden">
          <nav className="mx-auto flex max-w-6xl flex-col px-4 py-3" aria-label="モバイルナビゲーション">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="border-b border-navy-100 py-3 text-sm font-medium text-navy-800 transition-colors hover:text-navy-950"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-3 whitespace-nowrap rounded-md bg-lime-400 px-5 py-3 text-center text-sm font-bold text-navy-950 transition-colors hover:bg-lime-500"
            >
              公開日について相談する
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}